export default __webpack_public_path__ + "static/1328-b76381c56c013b41ba9b21e365d2a372.gif";